import { render } from "./AddStorageType.vue?vue&type=template&id=96c37d6a"
import script from "./AddStorageType.vue?vue&type=script&lang=js"
export * from "./AddStorageType.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__